import { makeStyles } from '@material-ui/core';

export default makeStyles(({ spacing, palette }: any) => ({
  minViewHeight: {
    minHeight: 'calc(100% - 40px)',
  },
  alternativeLayout: {
    display: 'block',
    background: palette.background.default,
  },
  layout: {
    padding: `${spacing(8)}px ${spacing(5)}px ${spacing(13)}px`,
    backgroundColor: palette.background.default,
  },
  fullHeightContent: {
    height: '100%',
    paddingTop: 0,
    paddingBottom: 0,
  },
  orderConfirmationStyling: {
    height: '100%',
    paddingTop: 0,
    paddingBottom: 0,
    background: palette.background.header,
  },
  header: {
    position: 'sticky',
    top: '0px',
    zIndex: 2,
    left: '0px',
    right: '0px',
    width: '100%',
  },
  container: {
    overflow: 'hidden',
  },
  flexLayout: {
    display: 'flex',
    height: 'calc(100% - 40px)',
  },
}));
